<div class="min-h-screen bg-base-200 p-4">
  <div class="max-w-2xl mx-auto">
    <div class="card bg-base-100 shadow-xl">
      <div class="card-body">
        <h2 class="card-title text-2xl mb-6">Edit Profile</h2>

        @if (errorMessage) {
          <div data-testid="profile-edit-error-alert" class="alert alert-error mb-4">
            <app-icon name="x-circle" type="heroicon" class="stroke-current shrink-0 h-6 w-6"></app-icon>
            <span>{{ errorMessage }}</span>
          </div>
        }

        @if (successMessage) {
          <div data-testid="profile-edit-success-alert" class="alert alert-success mb-4">
            <app-icon name="check-circle" type="heroicon" class="stroke-current shrink-0 h-6 w-6"></app-icon>
            <span>{{ successMessage }}</span>
          </div>
        }

        <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" data-testid="profile-edit-form" class="space-y-4">
          <div class="form-control">
            <label class="label" for="name">
              <span class="label-text font-medium">Name</span>
            </label>
            <input
              id="name"
              type="text"
              formControlName="name"
              class="input input-bordered w-full"
              [class.input-error]="profileForm.get('name')?.invalid && profileForm.get('name')?.touched"
              placeholder="Enter your name"
              >
            @if (profileForm.get('name')?.invalid && profileForm.get('name')?.touched) {
              <div class="label">
                @if (profileForm.get('name')?.errors?.['required']) {
                  <span class="label-text-alt text-error">Name is required.</span>
                }
                @if (profileForm.get('name')?.errors?.['minlength']) {
                  <span class="label-text-alt text-error">Name must be at least 2 characters.</span>
                }
                @if (profileForm.get('name')?.errors?.['maxlength']) {
                  <span class="label-text-alt text-error">Name must not exceed 100 characters.</span>
                }
                @if (profileForm.get('name')?.errors?.['pattern']) {
                  <span class="label-text-alt text-error">Please enter a valid name (letters, spaces, hyphens only).</span>
                }
              </div>
            }
          </div>

          <div class="form-control">
            <label class="label" for="email">
              <span class="label-text font-medium">Email</span>
            </label>
            <input
              id="email"
              type="email"
              formControlName="email"
              readonly
              class="input input-bordered w-full input-disabled"
              placeholder="Your email address"
              >
            <div class="label">
              <span class="label-text-alt">Email cannot be changed</span>
            </div>
            @if (profileForm.get('email')?.invalid && profileForm.get('email')?.touched) {
              <div class="label">
                <span class="label-text-alt text-error">Valid email is required.</span>
              </div>
            }
          </div>

          <div class="form-control">
            <label class="label" for="location">
              <span class="label-text font-medium">Location <span class="text-base-content/50">(optional)</span></span>
            </label>
            <input
              id="location"
              type="text"
              formControlName="location"
              class="input input-bordered w-full"
              placeholder="Enter your location"
              >
            <div class="label">
              <span class="label-text-alt">This information helps personalize your experience</span>
            </div>
          </div>

          <div class="form-control mt-6">
            <button
              type="submit"
              data-testid="profile-edit-submit-btn"
              [disabled]="profileForm.invalid || isLoading"
              class="btn btn-primary w-full">
              @if (isLoading) {
                <span data-testid="profile-edit-submit-spinner" class="loading loading-spinner loading-sm"></span>
              }
              @if (isLoading) {
                <span>Saving...</span>
              }
              @if (!isLoading) {
                <span>Save Changes</span>
              }
            </button>
          </div>
        </form>

        <div class="divider"></div>

        <div class="card-actions">
          <a routerLink="/dashboard" data-testid="profile-edit-back-link" class="btn btn-outline">
            <app-icon name="arrow-left" type="heroicon" class="h-4 w-4 mr-1"></app-icon>
            Back to Dashboard
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
